var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#ECEDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12722 11.3333L3.88574 20.9957H8.96339L9.59287 19.4551H11.0317L11.6612 20.9957H17.2503V19.8198L17.7483 20.9957H20.6394L21.1374 19.795V20.9957H32.7611L34.1745 19.4951L35.498 20.9957L41.4682 21.0081L37.2133 16.1915L41.4682 11.3333H35.5906L34.2147 12.8062L32.9329 11.3333H20.2878L19.202 13.8273L18.0907 11.3333H13.0237V12.4691L12.46 11.3333H8.12722ZM9.11017 12.7054H11.5852L14.3986 19.2575V12.7054H17.11L19.283 17.4032L21.2857 12.7054H23.9835V19.6388H22.3419L22.3285 14.2058L19.9353 19.6388H18.4668L16.0602 14.2058V19.6388H12.6832L12.0429 18.0844H8.58403L7.94513 19.6374H6.13574L9.11017 12.7054ZM32.1603 12.7054H25.4854V19.6347H32.0569L34.175 17.3382L36.2165 19.6347H38.3507L35.2488 16.1901L38.3507 12.7054H36.3091L34.2018 14.9755L32.1603 12.7054ZM10.3134 13.8785L9.17383 16.6475H11.4516L10.3134 13.8785ZM27.1328 15.4066V14.1409V14.1397H31.2977L33.1151 16.1639L31.2172 18.1991H27.1328V16.8173H30.7743V15.4066H27.1328Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.eb9deba44d1770665e5cca7465ed3996.svg";
export { ForwardRef as ReactComponent };